import React, { Component } from "react";
import { DKIcon, DKLabel, DKLine } from "deskera-ui-library";
import Incrementor from "../../common/Incrementor";
import ApiManager from "../../../managers/ApiManager";
import SegmentControl from "../../common/SegmentControl";

/*
PROPS
- data // this is current components data
- onDataChange
- className
*/

export default class ImageTextEditor extends Component {
  constructor(props) {
    super(props);
    this.componentData = this.props.data;
  }
  render() {
    return (
      <div
        className={
          "column parent-width border-box mt-m border-radius-s p-r border-m shadow-s " +
          this.props.className
        }
      >
        {this.getAllItems(this.componentData.value)}

        <DKLine style={{ height: 3 }} className="mt-s mb-xl" />

        <Incrementor
          className=""
          title="Image size"
          UOM="%"
          value={this.componentData.style.imageSize}
          onChange={(value) => {
            this.containerCal("imageSize", value);
          }}
        />
        <Incrementor
          className="mt-l"
          title="Container Size"
          value={this.componentData.style.containerSpacing}
          UOM="%"
          onChange={(value) => {
            this.containerCal("containerSpacing", value);
          }}
        />
        <Incrementor
          className="mt-l"
          title="Image spacing"
          UOM="%"
          value={this.componentData.style.cellSpacing}
          onChange={(value) => {
            this.containerCal("cellSpacing", value);
          }}
        />
        <Incrementor
          className="mt-l"
          title="Image corners"
          value={this.componentData.style.imageRadius}
          onChange={(value) => {
            this.changeStyle("imageRadius", value);
          }}
        />

        <DKLine style={{ height: 3 }} className="mt-xl mb-xl" />

        <DKLabel text="Image Position" className="fw-m mb-s" />
        <SegmentControl
          data={[
            { title: "Left", value: "left" },
            { title: "Right", value: "right" },
          ]}
          onChange={this.changeImageSelfAlignment}
          value={this.componentData.style.imageAlign}
        />

        <DKLabel text="Text Alignment" className="fw-m mt-l mb-s" />
        <SegmentControl
          data={[
            { title: "Left", value: "left" },
            { title: "Center", value: "center" },
            { title: "Right", value: "right" },
          ]}
          onChange={this.changeTextSelfAlignment}
          value={this.componentData.style.textAlign}
        />

        <DKLine style={{ height: 3 }} className="mt-xxl mb-xl" />

        <div className=" row">
          <Incrementor
            title="Header"
            value={this.componentData.style.titleSize}
            onChange={(value) => {
              this.changeStyle("titleSize", value);
            }}
          />
          <div className="mt-l">
            <input
              type="color"
              className="ml-r"
              value={this.componentData.style.titleColor}
              onChange={(e) => this.changeStyle("titleColor", e.target.value)}
            />
          </div>
        </div>

        <div className="mt-s row mb-l">
          <Incrementor
            className="mt-l parent-width"
            title="Description"
            value={this.componentData.style.descriptionSize}
            onChange={(value) => {
              this.changeStyle("descriptionSize", value);
            }}
          />
          <div className="mt-l">
            <input
              type="color"
              className="ml-r"
              value={this.componentData.style.descriptionColor}
              onChange={(e) =>
                this.changeStyle("descriptionColor", e.target.value)
              }
            />
          </div>
        </div>
      </div>
    );
  }

  getAllItems(items) {
    let arr = [];
    items.forEach((item, index) => {
      arr.push(this.getItemRow(item, index));
    });
    return arr;
  }
  getItemRow(item, index) {
    return (
      <div className="row mb-l">
        <div className="position-relative">
          <DKIcon
            src={item.image}
            className="mr-s ic-l  unselectable border-m shadow-s"
          />
          <div
            className="position-absolute cursor-hand"
            style={{ top: 0, left: 0, width: 50, height: 50 }}
          >
            <input
              className=" cursor-hand "
              style={{ width: "100%", height: "100%", opacity: 0 }}
              type="file"
              accept="image/*"
              onChange={(e) => {
                this.uploadImageToAWS(e.target.files[0], index);
              }}
            />
          </div>
        </div>
        <div className="column  ml-xs parent-width ">
          <div className="row">
            <input
              className="parent-width border-box p-v-s p-h-s bg-gray1 border-none border-radius-s border-m mt-s"
              type="text"
              value={item.title}
              onChange={(e) => this.changeValue("title", e.target.value, index)}
              placeholder="Title"
            />
          </div>
          <input
            className="parent-width border-box p-v-s p-h-s bg-gray1 border-none border-radius-s border-m mt-s"
            type="text"
            value={item.description}
            onChange={(e) =>
              this.changeValue("description", e.target.value, index)
            }
            placeholder="Description"
          />
        </div>
      </div>
    );
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  changeStyle = (property, value) => {
    let style = { ...this.componentData.style };
    style[property] = value;
    this.componentData.style = style;
    this.props.onDataChange(this.componentData);
  };

  changeValue = (property, value, index) => {
    let new_value = this.componentData.value;
    new_value[index][property] = value;
    this.componentData.value = new_value;
    this.props.onDataChange(this.componentData);
  };

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  uploadImageToAWS(imageData, index) {
    ApiManager.getUploadFileURL(
      imageData,
      (url) => {
        this.changeValue("image", url, index);
      },
      (err) => {
        alert("Upload failed");
      }
    );
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  changeImageSelfAlignment = (alignment) => {
    let style = { ...this.componentData.style };
    style.imageAlign = alignment;
    this.componentData.style = style;
    this.props.onDataChange(this.componentData);
  };

  changeTextSelfAlignment = (alignment) => {
    let style = { ...this.componentData.style };
    style.textAlign = alignment;
    this.componentData.style = style;
    this.props.onDataChange(this.componentData);
  };

  containerCal = (key, value) => {
    let imageSize = this.componentData.style.imageSize;
    let continerSize = this.componentData.style.containerSpacing;
    let spacingSize = this.componentData.style.cellSpacing;
    switch (key) {
      case "imageSize":
        continerSize = 100 - value - spacingSize;
        imageSize = value;
        break;
      case "containerSpacing":
        imageSize = 100 - value - spacingSize;
        continerSize = value;
        break;
      case "cellSpacing":
        continerSize = continerSize + (spacingSize / 2 - value / 2);
        imageSize = imageSize + (spacingSize / 2 - value / 2);
        spacingSize = value;
        break;
      default:
        break;
    }

    this.changeStyle("imageSize", imageSize);
    this.changeStyle("containerSpacing", continerSize);
    this.changeStyle("cellSpacing", spacingSize);
  };
}
